import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { useAppSelector } from "src/app-redux/hooks";
import { selectWareHouseItemDetails } from "src/app-redux/warehouse/wareHouseSlice";
import { useStyles } from "./../style";
import moment from "moment";

export interface IDrawerDetailsProps {}

export default function DrawerDetails(props: IDrawerDetailsProps) {
  const classes = useStyles();
  // Redux
  const inventoryItemDetails: any = useAppSelector(selectWareHouseItemDetails);
  return (
    <div className={classes.drawerDetails}>
      {/* Item Details */}
      <Typography className="heading">Item Details </Typography>
      <Grid container spacing={2} className="topContainer">
        <Grid container direction="row" className="itemRow">
          <Grid md={1}></Grid>
          <Grid md={6}>
            <Typography className="subHeading">Name</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.name ? inventoryItemDetails.itemDetail.name : "-"}
            </Typography>
          </Grid>
          <Grid md={5}>
            <Typography className="subHeading">Item Code</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.itemCode
                ? inventoryItemDetails.itemDetail.itemCode
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        {/* <Grid container direction="row" className="itemRow">
          <Grid md={1}></Grid>
          <Grid md={6}>
            <Typography className="subHeading">Model Number</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.modelNumber
                ? inventoryItemDetails.itemDetail.modelNumber
                : "-"}
            </Typography>
          </Grid>
          <Grid md={5}>
            <Typography className="subHeading">Serial Number</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.serialNumber
                ? inventoryItemDetails.itemDetail.serialNumber
                : "-"}
            </Typography>
          </Grid>
        </Grid> */}

        <Grid container direction="row" className="itemRow">
          <Grid md={1}></Grid>
          {/* <Grid md={6}>
            <Typography className="subHeading">Type of Shipment</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.consignmentType
                ? inventoryItemDetails.itemDetail.consignmentType
                : "-"}
            </Typography>
          </Grid> */}
          {/* <Grid md={6}>
            <Typography className="subHeading">Type of Cargo</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.cargoType
                ? inventoryItemDetails.itemDetail.cargoType
                : "-"}
            </Typography>
          </Grid> */}
          <Grid md={6}>
            <Typography className="subHeading">Reason for Entry</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.entryReason
                ? inventoryItemDetails.itemDetail.entryReason
                : "-"}
            </Typography>
          </Grid>
          <Grid md={5}>
            <Typography className="subHeading">Location at Warehouse</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.warehouse
                ? inventoryItemDetails.itemDetail.warehouse
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid md={1}></Grid>

          <Grid md={6}>
            <Typography className="subHeading">Item Status</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.status
                ? inventoryItemDetails.itemDetail.status
                : "-"}
            </Typography>
          </Grid>
          <Grid md={5}>
            <Typography className="subHeading">Inspection Status</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.inspectionStatus
                ? inventoryItemDetails.itemDetail.inspectionStatus
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid md={1}></Grid>

          <Grid md={6}>
            <Typography className="subHeading">Inventory Type</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.isDetained
                ? "Detained"
                : inventoryItemDetails.itemDetail?.isDetained == false &&
                  inventoryItemDetails.itemDetail?.isBannedItem == false
                ? "Cargo"
                : "Seized"}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* Driver & Vehicle Details */}
      <Typography className="heading">Driver & Vehicle Details </Typography>
      <Grid container spacing={2} className="topContainer">
        <Grid container direction="row" className="itemRow">
          <Grid md={1}></Grid>
          <Grid md={6}>
            <Typography className="subHeading">Vehicle Number</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.vehicleNumber
                ? inventoryItemDetails.itemDetail.vehicleNumber
                : "-"}
            </Typography>
          </Grid>
          <Grid md={5}>
            <Typography className="subHeading">Driver Name</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.driverName
                ? inventoryItemDetails.itemDetail.driverName
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid md={1}></Grid>
          <Grid md={6}>
            <Typography className="subHeading">Importer Name</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.importerName
                ? inventoryItemDetails.itemDetail?.importerName
                : "-"}
            </Typography>
          </Grid>
          <Grid md={5}>
            <Typography className="subHeading">Exporter Name</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.exporterName
                ? inventoryItemDetails.itemDetail?.exporterName
                : "-"}
            </Typography>
          </Grid>
          {/* <Grid md={5}>
            <Typography className="subHeading">Importer Phone Number</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.importerPhoneNumber
                ? inventoryItemDetails.itemDetail?.importerPhoneNumber
                : "-"}
            </Typography>
          </Grid> */}
        </Grid>

        <Grid container direction="row" className="itemRow">
          <Grid md={1}></Grid>

          {/* <Grid md={5}>
            <Typography className="subHeading">Exporter Phone Number</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail &&
              inventoryItemDetails.itemDetail?.exporterPhoneNumber
                ? inventoryItemDetails.itemDetail?.exporterPhoneNumber
                : "-"}
            </Typography>
          </Grid> */}
        </Grid>
      </Grid>
      {/* Handover Details */}
      <Typography className="heading">Handover Details </Typography>
      <Grid container spacing={2} className="topContainer">
        <Grid container direction="row" className="itemRow">
          <Grid md={1}></Grid>
          <Grid md={6}>
            <Typography className="subHeading">Name</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.detainedByName
                ? inventoryItemDetails.itemDetail?.detainedByName
                : "-"}
            </Typography>
          </Grid>
          <Grid md={5}>
            <Typography className="subHeading">Department</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.detainedByDepartment
                ? inventoryItemDetails.itemDetail?.detainedByDepartment
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid md={1}></Grid>
          <Grid md={6}>
            <Typography className="subHeading">Designation</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.detainedByDesignation
                ? inventoryItemDetails.itemDetail?.detainedByDesignation
                : "-"}
            </Typography>
          </Grid>
          <Grid md={5}></Grid>
        </Grid>
      </Grid>
      {/* Item Specifictions Details */}
      <Typography className="heading">Item Specifications </Typography>
      <Grid container spacing={2} className="topContainer">
        <Grid container direction="row" className="itemRow">
          <Grid md={1}></Grid>
          <Grid md={6}>
            <Typography className="subHeading">Quantity</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.weight
                ? `${inventoryItemDetails.itemDetail.weight} ${
                    inventoryItemDetails.itemDetail?.weightUnit == "Cubic meter"
                      ? "m³"
                      : inventoryItemDetails.itemDetail?.weightUnit
                  }`
                : "-"}
            </Typography>
          </Grid>
          <Grid md={5}>
            <Typography className="subHeading">Entry Date & Time</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.entryDate
                ? moment(inventoryItemDetails.itemDetail.entryDate).format("DD-MM-YYYY hh:mm A")
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid md={1}></Grid>
          <Grid md={6}>
            {/* <Typography className="subHeading">Value</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.cargoValue
                ? `${inventoryItemDetails.itemDetail.cargoValue} 
                ${inventoryItemDetails.itemDetail?.cargoValueCurrency}`
                : "-"}
            </Typography> */}
            <Typography className="subHeading">Remarks</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.remarks
                ? inventoryItemDetails.itemDetail.remarks
                : "-"}
            </Typography>
          </Grid>
          <Grid md={5}>
            {/* <Typography className="subHeading">Remarks</Typography>
            <Typography className="subHeadingDetails">
              {inventoryItemDetails.itemDetail?.remarks
                ? inventoryItemDetails.itemDetail.remarks
                : "-"}
            </Typography> */}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
